import React, {FC} from 'react';

import mobileLogo from 'assets/images/mobileLogo.png';

import CustomImage from 'components/CustomImage/CustomImage';

import {getOrganizationMediaSource} from 'helpers/mediaHelper';

import {ORGANIZATION_MEDIA_MAIN_LOGO, ORGANIZATION_MEDIA_NAVBAR_LOGO} from 'config/index';

interface MainLogoType {
    withBorderRadius?: boolean;
    navBar?: boolean;
    isMobileMenu?: boolean;
    maxWidth?: number;
    maxHeight?: number;
}

const MainLogo: FC<MainLogoType> = ({withBorderRadius, maxWidth, maxHeight, navBar, isMobileMenu}) => {
    const logo = navBar
        ? getOrganizationMediaSource(ORGANIZATION_MEDIA_NAVBAR_LOGO)
        : getOrganizationMediaSource(ORGANIZATION_MEDIA_MAIN_LOGO);

    if (logo) {
        return (
            <CustomImage
                imageSrc={logo}
                snippetImage={withBorderRadius}
                isMobileMenu={isMobileMenu}
                maxWidth={maxWidth}
                maxHeight={maxHeight}
            />
        );
    }
    return <img src={mobileLogo} style={{maxWidth: '100%'}} alt={'Herupu logo'} />;
};

export default MainLogo;
